//Imports
import React, { useCallback, useEffect } from "react";

//Controls
import { Button, Modal } from "@gpstrackit/gtc-react-controls";

//Components
import {
    NotificationManager,
    NotificationContainer,
} from "Components/Notifications";

//Hooks
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";

//Actions
import { deleteTemplate, reset } from "./redux/slice";

const DeleteTemplate = ({ onRefresh }) => {
    //Redux
    const dispatch = useDispatch();
    const { open, loading, result, error, items } = useSelector((state) => state.templateDeleteRedux);

    //Language
    const { messages } = useIntl();

    //Handlers and utils
    const handleClose = useCallback((refresh) => {
        dispatch(reset());
        onRefresh && onRefresh(refresh);
    });

    //Effects
    useEffect(() => {
        if (error) {
            //clear redux error
            dispatch(reset({ error: null }));

            //show error notification
            NotificationManager.error(
                messages["errorMessage"],
                messages["error"],
                3000,
                null,
                null,
                "error"
            );

        }

        if (result) {
            //clear redux result
            dispatch(reset({ result: null }));

            //show success notification
            NotificationManager.success(
                messages["templateDelete_Success"],
                messages["success"],
                3000,
                null,
                null,
                "success"
            );

            handleClose(true);
        }
    }, [result, error]);

    return (
        <Modal
            title={messages["templateDeteleTitle"]}
            size="small"
            open={open}
            handleClose={handleClose}
            loading={loading}
            footer={
                <div>
                    <Button
                        variant="secondary"
                        style={{ marginRight: "5px" }}
                        onClick={() => handleClose()}
                        isDisabled={loading}
                    >
                        {messages["cancel"]}
                    </Button>
                    <Button
                        variant="warning"
                        onClick={() => dispatch(deleteTemplate({ ids: items.map((item) => item.id) }))}
                        isDisabled={loading}
                    >
                        {messages["delete"]}
                    </Button>
                </div>
            }
        >
            <div style={{ padding: "10px 25px" }}>
                <p>{messages["manage_deleteManageCrew_confirmationMessage"]}</p>
                <ul>
                    {
                        items?.map((item) => (
                            <li>
                                {item.firstName} {item.lastName}
                            </li>
                        ))
                    }
                </ul>
            </div>
            <NotificationContainer />
        </Modal>
    );
};

export default DeleteTemplate;